module.exports = __webpack_public_path__ + "img/Fahrerseite_1T_Frontmotor.c4111699.jpg";